import React, { SyntheticEvent, useEffect, useState } from 'react'

import { SxProps } from '@mui/material'

import { useHistory, useLocation } from 'react-router-dom'

import { useNavigationItems } from './utils'

import BottomNavigation from 'components_new/atoms/BottomNavigation'
import BottomNavigationAction from 'components_new/atoms/BottomNavigationAction'
import Icon from 'components_new/atoms/Icon'

interface GlobalMobileNavigationProps {
  sx?: SxProps
}

const GlobalMobileNavigation = (props: GlobalMobileNavigationProps) => {
  const { sx } = props

  const history = useHistory()
  const location = useLocation()

  const navigationItems = useNavigationItems()

  const [value, setValue] = useState<string>(location.pathname ?? '/dashboards')

  useEffect(() => {
    if (location.pathname.includes('/dashboards/folders')) {
      setValue('/dashboards')
    } else {
      setValue(location.pathname)
    }
  }, [location])

  const handleOnChange = (_: SyntheticEvent, newValue: any) => {
    history.push(newValue)
  }

  return (
    <BottomNavigation
      showLabels={true}
      value={value}
      onChange={handleOnChange}
      sx={{
        height: '100%',
        ...sx
      }}
    >
      {navigationItems.map((item) => {
        if (item.hidden) return null

        return (
          <BottomNavigationAction
            key={item.value}
            label={item.label}
            icon={<Icon name={item.iconName} />}
            sx={{
              ['& .Mui-selected']: {
                fontSize: '0.75rem!important'
              }
            }}
            value={item.value}
          />
        )
      })}
    </BottomNavigation>
  )
}

export default GlobalMobileNavigation
